module.exports = __webpack_public_path__ + "static/media/Sarabun-Regular.56c5f9d4.ttf";